import React from "react";
import { useState } from "react";

import brandingft1 from "../assets/brandingft2.png";
import bannerVuonTam from "../assets/footer/tinhoahoitu1.png";
import eventImg from "../assets/footer/imgbaivietfooter.png";
import app from "../assets/footer/app.png";
import youtubeNew from "../assets/footer/youtube.png";
import telegramNew from "../assets/footer/telegg88.png";
import facebookIcon from "../assets/footer/face.png";
import titleNews from "../assets/footer/title-news1.png";
import tiktok from "../assets/footer/tiktok.png";
import plasticft from "../assets/footer/plasticft.png";

import brand1 from "../assets/footer/brand1.png";
import brand2 from "../assets/footer/brand2.png";
import brand3 from "../assets/footer/brand3.png";
import brand4 from "../assets/footer/brand4.png";
import brand5 from "../assets/footer/brand5.png";
import brand6 from "../assets/footer/brand6.png";
import brand7 from "../assets/footer/brand7.png";
import brand8 from "../assets/footer/brand8.png";

import secureIcon from "../assets/footer/Group.png";

const Footer = () => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  return (
    <>
      {/* Desktop Footer */}

      {/* Desktop Footer (match mockup mới) */}
      <footer className="hidden md:block bg-black">
        <div className="container mx-auto px-8 lg:px-16 xl:px-24 py-8">
          {/* HÀNG TRÊN: TRÁI / GIỮA / PHẢI */}
          <div className="flex flex-col lg:flex-row gap-8 items-start justify-between">
            {/* TRÁI */}
            <div className="shrink-0">
              <img
                src={brandingft1}
                alt="Juventus FC & KJC - Đối Tác Chính Thức Năm 2025-2026"
                className="h-[170px] xl:h-[186px] w-auto object-contain select-none"
                loading="lazy"
              />
            </div>

            {/* GIỮA */}
            <div className="flex-1">
              <h3
                className="text-[20px] font-extrabold uppercase leading-tight tracking-tighter line-clamp-2 "
                style={{
                  display: "-webkit-box",
                  WebkitLineClamp: 2, // clamp tiêu đề 2 dòng
                  WebkitBoxOrient: "vertical",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  backgroundImage: "linear-gradient(90deg, #FEE3AA 0%, #EAC367 31%, #CD9640 73%, #EEBE7A 100%)",
                  overflow: "hidden",
                }}
              >
                KJC | Juventus – Đối tác độc quyền khu vực Châu Á
              </h3>

              <p
                className="mt-1 text-[#ffffff] text-[14px] leading-6 tracking-tight"
                style={
                  isCollapsed
                    ? {
                      display: "-webkit-box",
                      WebkitLineClamp: 2, // khi Ẩn bớt: chỉ còn 2 dòng
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                    }
                    : undefined // khi Xem thêm: hiện đầy đủ
                }
              >
                KJC hợp tác độc quyền với CLB Juventus tại châu Á, đưa thương
                hiệu vươn tầm quốc tế. Juventus – biểu tượng bóng đá thế giới
                với nhiều danh hiệu lẫy lừng – trở thành đại sứ độc quyền, nâng
                uy tín và tầm ảnh hưởng...
              </p>

              <button
                className="mt-1 text-[#EAC367] text-sm hover:underline"
                onClick={() => setIsCollapsed((v) => !v)}
                style={{
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  backgroundImage: "linear-gradient(90deg, #FEE3AA 0%, #EAC367 31%, #CD9640 73%, #EEBE7A 100%)",
                }}
              >
                {isCollapsed ? "Xem thêm" : "Ẩn bớt"}
              </button>
            </div>

            {/* PHẢI — giữ nguyên sát lề như bạn đang để */}
            <div className="shrink-0 w-[226px] h-[150px]">
              <div className="rounded-xl overflow-hidden ring-1 ring-black/10 w-full h-full mx-auto lg:mx-0">
                <img
                  src={eventImg}
                  alt="Sự kiện ký kết"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
            </div>
          </div>

          {/* LINK ĐIỀU HƯỚNG */}
          <div className="mt-6 flex flex-wrap items-center justify-center gap-y-2 text-sm text-[#ffffff]">
            {[
              {
                text: "Giới thiệu về VND88",
                link: "https://alo838.com/home/about-detail/3810221",
              },
              {
                text: "Điều khoản & điều kiện",
                link: "https://alo838.com/home/about-detail/3810221",
              },
              {
                text: "Chơi có trách nhiệm",
                link: "https://alo838.com/home/about-detail/3810221",
              },
              {
                text: "Miễn trách nhiệm",
                link: "https://alo838.com/home/about-detail/3810221",
              },
              {
                text: "Quyền riêng tư",
                link: "https://alo838.com/home/about-detail/3810221",
              },
              {
                text: "Hướng dẫn nạp rút",
                link: "https://alo838.com/home/about-detail/3810221",
              },
              {
                text: "Câu hỏi thường gặp",
                link: "https://alo838.com/home/about-detail/3810221",
              },
              {
                text: "Liên hệ",
                link: "https://alo838.com/home/about-detail/3810221",
              },
            ].map((item, i, arr) => (
              <React.Fragment key={item.text}>
                <a
                  href={item.link}
                  className="hover:underline whitespace-nowrap"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {item.text}
                </a>
                {i < arr.length - 1 && (
                  <span className="mx-3 text-gray-300">|</span>
                )}
              </React.Fragment>
            ))}
          </div>

          {/* ICON CHỨNG NHẬN */}
          <div className="mt-6 flex items-center justify-center gap-[62px] flex-nowrap overflow-x-auto">
            {[
              secureIcon,
              brand1,
              brand2,
              brand3,
              brand4,
              brand5,
              brand6,
              // brand7,
              brand8,
            ].map((src, i) => (
              <img
                key={i}
                src={src}
                alt={`badge-${i + 1}`}
                className="h-7 w-auto object-contain shrink-0"
                loading="lazy"
              />
            ))}

            <a
              href="https://clxx.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={brand7}
                alt="brand7"
                className="h-7 w-auto cursor-pointer hover:opacity-80 transition-opacity shrink-0"
              />
            </a>

            {/* social */}
            <a
              href="https://www.facebook.com/alo8trangchu"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={facebookIcon}
                alt="Facebook"
                className="h-7 w-auto cursor-pointer hover:opacity-80 transition-opacity shrink-0"
              />
            </a>
            <a
              href="https://www.tiktok.com/@escuelaalejandrog"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={tiktok}
                alt="tiktok"
                className="h-7 w-auto cursor-pointer hover:opacity-80 transition-opacity shrink-0"
              />
            </a>
            <a
              href="https://www.youtube.com/@munkeebutt420"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={youtubeNew}
                alt="YouTube"
                className="h-7 w-auto cursor-pointer hover:opacity-80 transition-opacity shrink-0"
              />
            </a>
            <a
              href="https://t.me/addlist/WHIrlvW7ShQxN2M1"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={telegramNew}
                alt="Telegram"
                className="h-7 w-auto cursor-pointer hover:opacity-80 transition-opacity shrink-0"
              />
            </a>
          </div>
        </div>
      </footer>

      {/* Mobile */}
      <footer className="md:hidden block bg-[#1A1A1A]">
        <div className="container mx-auto flex flex-col items-center px-4 py-4">
          <div
            className="w-full relative rounded-[10px] border border-white/60 mb-6"
            style={{
              borderColor: "#FFFFFF",
              borderWidth: "2px",
              boxShadow: "0px 2px 5.1px 0 rgba(88, 195, 181, 0.18)",
            }}
          >
            <div className="w-full flex justify-center p-2">
              <img
                src={brandingft1}
                alt="Juventus FC & KJC"
                className="w-full h-auto object-contain select-none"
                loading="lazy"
              />
            </div>
            <div className="w-full flex justify-center">
              <img
                src={titleNews}
                alt="Tin tức - Sự kiện nổi bật Alo8"
                className="w-full h-full max-w-full object-contain"
                loading="lazy"
              />
            </div>

            {/* Danh sách tin (theo mockup) */}
            <div className=" w-full space-y-1">
              {/* Tin 1 */}
              <div className="flex items-start gap-3  p-3">
                <div className="flex-1">
                  <h4
                    className="text-[15px] font-extrabold uppercase leading-[18px]"
                    style={{
                      display: "-webkit-box",
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                      backgroundImage: "linear-gradient(90deg, #FEE3AA 0%, #EAC367 31%, #CD9640 73%, #EEBE7A 100%)",
                    }}
                  >
                    KJC | Juventus – Đối tác độc quyền khu vực Châu Á
                  </h4>
                  <p className="mt-1 text-[12px] leading-4 text-[#FFFFFF]">
                    <span className="font-bold">KJC</span> hợp tác độc quyền với
                    CLB Juventus tại châu Á, đưa thương hiệu vươn tầm quốc tế.
                    Juventus – biểu tượng bóng đá thế giới…
                  </p>
                  <button className="mt-1 text-[#25C4AF] text-xs hover:underline"
                    style={{
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                      backgroundImage: "linear-gradient(90deg, #FEE3AA 0%, #EAC367 31%, #CD9640 73%, #EEBE7A 100%)",
                    }}>
                    Xem thêm
                  </button>
                </div>

                <div className="w-[150px] h-[120px] rounded-[12px] overflow-hidden ring-1 ring-black/10 shrink-0">
                  <img
                    src={eventImg}
                    alt="Sự kiện"
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
              </div>

              {/* Tin 2 */}
              <div className="flex items-start gap-3  p-3">
                <div className="flex-1">
                  <h4
                    className="text-[15px] font-extrabold uppercase leading-[18px]"
                    style={{
                      display: "-webkit-box",
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                      backgroundImage: "linear-gradient(90deg, #FEE3AA 0%, #EAC367 31%, #CD9640 73%, #EEBE7A 100%)",
                    }}
                  >
                    Ra mắt ứng dụng KJC nhận KM
                  </h4>
                  <p className="mt-1 text-[12px] leading-5 text-[#FFFFFF]">
                    <span className="font-bold">KJC</span> ra mắt ứng dụng Liên
                    Minh Quốc Tế – trải nghiệm tiện lợi, nhiều ưu đãi…
                  </p>
                  <button className="mt-1 text-[#25C4AF] text-xs hover:underline"
                    style={{
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                      backgroundImage: "linear-gradient(90deg, #FEE3AA 0%, #EAC367 31%, #CD9640 73%, #EEBE7A 100%)",
                    }}>
                    Xem thêm
                  </button>
                </div>

                <div className="w-[150px] h-[120px] rounded-[12px] overflow-hidden ring-1 ring-black/10 shrink-0">
                  <img
                    src={app}
                    alt="Ứng dụng KJC"
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Hàng trên: MXH + banner (GIỮ NGUYÊN) */}
          <div className="w-full">
            <div
              className="flex items-center justify-between gap-3 px-3 py-2"
              style={{

                backgroundImage: `url(${plasticft})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <div className="flex items-center gap-3">
                <a
                  href="https://t.me/addlist/WHIrlvW7ShQxN2M1"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={telegramNew}
                    alt="Telegram"
                    className="h-8 w-8 max-[344px]:w-[20px] max-[344px]:h-[20px]  max-[344px]:h-[20px] max-[360px]:w-[20px]  max-[360px]:h-[20px]"
                  />
                </a>
                <a
                  href="https://www.facebook.com/alo8trangchu"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={facebookIcon}
                    alt="Facebook"
                    className="h-8 w-8 max-[344px]:w-[20px] max-[344px]:h-[20px] max-[360px]:h-[20px]  max-[360px]:w-[20px]"
                  />
                </a>
                <a
                  href="https://www.youtube.com/@munkeebutt420"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={youtubeNew}
                    alt="YouTube"
                    className="h-8 w-8 max-[344px]:w-[20px] max-[344px]:h-[20px] max-[360px]:h-[20px]  max-[360px]:w-[20px]"
                  />
                </a>
                <a
                  href="https://www.tiktok.com/@escuelaalejandrog"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={tiktok}
                    alt="TikTok"
                    className="h-8 w-8 max-[344px]:w-[20px] max-[344px]:h-[20px] max-[360px]:h-[20px]  max-[360px]:w-[20px]"
                  />
                </a>
              </div>

              <img
                src={bannerVuonTam}
                alt="ALO8 - Vươn tầm đẳng cấp -"
                className="h-8 w-auto object-contain"
              />
            </div>
          </div>

          {/* Link điều hướng (GIỮ NGUYÊN) */}
          <div className="mt-4 text-center text-[#FFFFFF] text-[12px] leading-6 space-y-1">
            <div className="flex items-center justify-center flex-wrap gap-x-2">
              <a
                href="https://alo838.com/home/about-detail/3810221"
                className="hover:underline whitespace-nowrap"
                target="_blank"
                rel="noopener noreferrer"
              >
                Giới thiệu về VND88
              </a>
              <span className="text-gray-300">|</span>
              <a
                href="https://alo838.com/home/about-detail/3810221"
                className="hover:underline whitespace-nowrap"
              >
                Điều khoản & điều kiện
              </a>
              <span className="text-gray-300">|</span>
              <a
                href="https://alo838.com/home/about-detail/3810221"
                className="hover:underline whitespace-nowrap"
              >
                Chơi có trách nhiệm
              </a>
            </div>
            <div className="flex items-center justify-center flex-wrap gap-x-2">
              <a
                href="https://alo838.com/home/about-detail/3810221"
                className="hover:underline whitespace-nowrap"
              >
                Miễn trách nhiệm
              </a>
              <span className="text-gray-300">|</span>
              <a
                href="https://alo838.com/home/about-detail/3810221"
                className="hover:underline whitespace-nowrap"
              >
                Quyền riêng tư
              </a>
              <span className="text-gray-300">|</span>
              <a
                href="https://alo838.com/home/about-detail/3810221"
                className="hover:underline whitespace-nowrap"
              >
                Hướng dẫn nạp rút
              </a>
            </div>
            <div className="flex items-center justify-center flex-wrap gap-x-2">
              <a
                href="https://alo838.com/home/about-detail/3810221"
                className="hover:underline whitespace-nowrap"
              >
                Câu hỏi thường gặp
              </a>
              <span className="text-gray-300">|</span>
              <a
                href="https://alo838.com/home/about-detail/3810221"
                className="hover:underline whitespace-nowrap"
              >
                Liên hệ
              </a>
            </div>
          </div>

          {/* Icon chứng nhận (GIỮ NGUYÊN) */}
          <div className="mt-4 flex items-center justify-center gap-3 opacity-90 max-[344px]:w-[20px] max-[360px]:w-[20px]">
            {[
              secureIcon,
              brand1,
              brand2,
              brand3,
              brand4,
              brand5,
              brand6,
              brand7,
              brand8,
            ].map((src, i) => (
              <img
                key={i}
                src={src}
                alt={`badge-${i + 1}`}
                className="h-7 w-auto object-contain "
              />
            ))}
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
